import React from 'react';

const LogoInline = (props: any) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1053.8 160"
        {...props}
    >
        <defs>
            <style>
                {
                    ".cls-1{fill:#007dc3;}.cls-2{fill:#2b6ba9;}.cls-3{fill:#231f20;}.cls-4{fill:#ededed;}"
                }
            </style>
        </defs>
        <g id="Combined">
            <polygon
                className="cls-1"
                points="121.46 227.25 127.89 227.25 138.02 251.38 138.21 251.38 148.24 227.25 154.68 227.25 154.68 259.12 150.36 259.12 150.36 232.92 150.27 232.92 139.51 259.12 136.63 259.12 125.87 232.92 125.78 232.92 125.78 259.12 121.46 259.12 121.46 227.25"
            />
            <path
                className="cls-1"
                d="M184.33,247.47l-5.94-14.64h-.1l-6,14.64Zm-7.75-20.22h3.92l13.64,31.87h-5l-3.2-7.88H170.73l-3.15,7.88h-5Z"
            />
            <polygon
                className="cls-1"
                points="202.32 227.25 206.64 227.25 206.64 241.03 207 241.03 221.09 227.25 227.12 227.25 211.72 241.97 228.16 259.12 221.85 259.12 207 243.18 206.64 243.18 206.64 259.12 202.32 259.12 202.32 227.25"
            />
            <polygon
                className="cls-1"
                points="235.52 227.25 256.09 227.25 256.09 231.3 239.84 231.3 239.84 240.8 254.97 240.8 254.97 244.85 239.84 244.85 239.84 255.07 256.91 255.07 256.91 259.12 235.52 259.12 235.52 227.25"
            />
            <path
                className="cls-1"
                d="M301.36,247.47l-5.94-14.64h-.09l-6,14.64Zm-7.74-20.22h3.92l13.64,31.87h-5.05l-3.19-7.88H287.76l-3.15,7.88h-5Z"
            />
            <path
                className="cls-1"
                d="M340.23,241.3h5.67c3.42,0,6.85-.82,6.85-5.14S349.32,231,345.9,231h-5.67Zm-4.32-14.05h11.21c8.15,0,10.22,4.91,10.22,8.91a8.55,8.55,0,0,1-7.83,8.42l9,14.54h-5.4l-8.1-14h-4.82v14h-4.32Z"
            />
            <polygon
                className="cls-1"
                points="367.45 227.25 388.02 227.25 388.02 231.3 371.77 231.3 371.77 240.8 386.9 240.8 386.9 244.85 371.77 244.85 371.77 255.07 388.84 255.07 388.84 259.12 367.45 259.12 367.45 227.25"
            />
            <path
                className="cls-1"
                d="M425.15,242.56a11.77,11.77,0,1,0-23.54-.09c0,7,4.81,12.6,11.75,12.6s11.79-5.54,11.79-12.51m6.75,16.56H413.53c-9,0-16.52-6.79-16.52-16.3a16.1,16.1,0,0,1,16.48-16.38,15.92,15.92,0,0,1,16.25,15.94c0,5.4-2.57,10.71-7.29,12.87v.09h9.45Z"
            />
            <path
                className="cls-1"
                d="M444.22,227.25v19.54c0,4,2,9.09,8,9.09s8-5.13,8-9.09V227.25h4.32v20.22a12.34,12.34,0,1,1-24.67,0V227.25Z"
            />
            <polygon
                className="cls-1"
                points="476.2 227.25 496.77 227.25 496.77 231.3 480.52 231.3 480.52 240.8 495.65 240.8 495.65 244.85 480.52 244.85 480.52 255.07 497.59 255.07 497.59 259.12 476.2 259.12 476.2 227.25"
            />
            <path
                className="cls-1"
                d="M508.69,252.46a8,8,0,0,0,6.76,3.42c2.84,0,6.34-1.8,6.34-5.31,0-7.34-15.71-2.79-15.71-15.21,0-3.74,3.15-8.92,10.81-8.92,3.46,0,6.79.72,9.18,3.65l-3.51,3.19a6.7,6.7,0,0,0-5.67-2.79c-4.78,0-6.22,2.88-6.22,4.87,0,8.06,15.71,3.24,15.71,14.72,0,6.16-4.94,9.86-11.07,9.86-4.09,0-8-1.4-10.17-4.42Z"
            />
            <polygon
                className="cls-1"
                points="543.48 231.3 533.22 231.3 533.22 227.25 558.06 227.25 558.06 231.3 547.8 231.3 547.8 259.12 543.48 259.12 543.48 231.3"
            />
            <polygon
                className="cls-1"
                points="583.25 227.25 603.28 227.25 603.28 231.3 587.57 231.3 587.57 241.3 602.21 241.3 602.21 245.35 587.57 245.35 587.57 259.12 583.25 259.12 583.25 227.25"
            />
            <path
                className="cls-1"
                d="M639.78,243.18c0-7-4.73-12.69-12-12.69s-12,5.72-12,12.69,4.73,12.7,12,12.7,12-5.72,12-12.7m-28.63,0c0-9.45,6.88-16.74,16.61-16.74s16.61,7.29,16.61,16.74-6.89,16.76-16.61,16.76-16.61-7.3-16.61-16.76"
            />
            <path
                className="cls-1"
                d="M658.94,241.3h5.67c3.42,0,6.84-.82,6.84-5.14S668,231,664.61,231h-5.67Zm-4.33-14.05h11.21c8.15,0,10.23,4.91,10.23,8.91a8.55,8.55,0,0,1-7.84,8.42l9,14.54h-5.4l-8.1-14h-4.82v14h-4.33Z"
            />
            <polygon
                className="cls-1"
                points="709.38 231.3 699.11 231.3 699.11 227.25 723.97 227.25 723.97 231.3 713.7 231.3 713.7 259.12 709.38 259.12 709.38 231.3"
            />
            <polygon
                className="cls-1"
                points="732.59 227.25 736.91 227.25 736.91 240.48 753.44 240.48 753.44 227.25 757.76 227.25 757.76 259.12 753.44 259.12 753.44 244.54 736.91 244.54 736.91 259.12 732.59 259.12 732.59 227.25"
            />
            <polygon
                className="cls-1"
                points="769.99 227.25 790.56 227.25 790.56 231.3 774.31 231.3 774.31 240.8 789.43 240.8 789.43 244.85 774.31 244.85 774.31 255.07 791.37 255.07 791.37 259.12 769.99 259.12 769.99 227.25"
            />
            <path
                className="cls-1"
                d="M822.41,255.35h6.35c2.61,0,6.88-.91,6.88-5.41,0-3.78-2.65-5.67-6.84-5.67h-6.39Zm0-14.87h5.9c3.28,0,5.93-1.29,5.93-4.77,0-2.52-1.57-4.67-5-4.67h-6.79Zm-4.32-13.23h11.07c5.54,0,9.68,2.57,9.68,8,0,3.65-2.25,5.94-5.49,7v.08a7.7,7.7,0,0,1,6.89,7.93c0,5.71-5,8.86-11.22,8.86H818.09Z"
            />
            <polygon
                className="cls-1"
                points="850.48 227.25 871.05 227.25 871.05 231.3 854.8 231.3 854.8 240.8 869.93 240.8 869.93 244.85 854.8 244.85 854.8 255.07 871.86 255.07 871.86 259.12 850.48 259.12 850.48 227.25"
            />
            <path
                className="cls-1"
                d="M883,252.46a8,8,0,0,0,6.75,3.42c2.84,0,6.35-1.8,6.35-5.31,0-7.34-15.71-2.79-15.71-15.21,0-3.74,3.15-8.92,10.8-8.92,3.47,0,6.8.72,9.19,3.65l-3.51,3.19a6.72,6.72,0,0,0-5.68-2.79c-4.77,0-6.21,2.88-6.21,4.87,0,8.06,15.71,3.24,15.71,14.72,0,6.16-4.95,9.86-11.07,9.86-4.1,0-8-1.4-10.17-4.42Z"
            />
            <polygon
                className="cls-1"
                points="917.75 231.3 907.49 231.3 907.49 227.25 932.34 227.25 932.34 231.3 922.08 231.3 922.08 259.12 917.75 259.12 917.75 231.3"
            />
            <polygon
                className="cls-2"
                points="576.47 0 482.53 197.93 486.79 201.75 580.68 3.92 576.47 0"
            />
            <polygon
                className="cls-3"
                points="52.28 164.71 33.6 177.98 36.79 199.89 25.65 199.89 24.25 184.65 14.86 191.25 10.39 199.89 0 199.89 18.39 164.71 28.77 164.71 21.86 177.86 21.91 177.98 38.73 164.71 52.28 164.71"
            />
            <path
                className="cls-3"
                d="M56.33,192.47a9,9,0,0,0,5.82-2.37,22.51,22.51,0,0,0,4.95-6A31.17,31.17,0,0,0,69.71,179c.72-2.25.72-4,0-5.11a3.92,3.92,0,0,0-3.6-1.73,8.87,8.87,0,0,0-5.55,2.18,21.19,21.19,0,0,0-4.91,5.78,30.64,30.64,0,0,0-3,6.15,5.69,5.69,0,0,0,.07,4.47c.62,1.18,1.82,1.77,3.59,1.77M69.8,164.11q7.62,0,9.81,4.31T79.79,179a34.6,34.6,0,0,1-2.43,5.53A33.8,33.8,0,0,1,72.75,191,29.89,29.89,0,0,1,66,196.61a25.08,25.08,0,0,1-6.78,3.1,24.44,24.44,0,0,1-6.14.78q-7.12,0-9.91-3.82T42.64,186a32.09,32.09,0,0,1,3.23-7,36.7,36.7,0,0,1,5-6.45,29.4,29.4,0,0,1,6.47-5.09,22.35,22.35,0,0,1,6.52-2.68,29.24,29.24,0,0,1,5.91-.62"
            />
            <path
                className="cls-3"
                d="M95.12,192.47a9.06,9.06,0,0,0,5.82-2.37,22.7,22.7,0,0,0,5-6A31.17,31.17,0,0,0,108.5,179c.72-2.25.72-4,0-5.11a3.92,3.92,0,0,0-3.6-1.73,8.87,8.87,0,0,0-5.55,2.18,21.19,21.19,0,0,0-4.91,5.78,30.64,30.64,0,0,0-3,6.15,5.64,5.64,0,0,0,.07,4.47c.62,1.18,1.81,1.77,3.59,1.77m13.47-28.36q7.62,0,9.81,4.31t.17,10.59a32.88,32.88,0,0,1-2.43,5.53,33.28,33.28,0,0,1-4.6,6.43,29.89,29.89,0,0,1-6.71,5.64,25.08,25.08,0,0,1-6.78,3.1,24.44,24.44,0,0,1-6.14.78q-7.14,0-9.91-3.82T81.42,186a32.6,32.6,0,0,1,3.24-7,36.64,36.64,0,0,1,5-6.45,29.68,29.68,0,0,1,6.48-5.09,22.3,22.3,0,0,1,6.51-2.68,29.33,29.33,0,0,1,5.92-.62"
            />
            <polygon
                className="cls-3"
                points="158.78 164.71 154.31 173.35 143.49 173.35 129.55 199.89 119.21 199.89 133.12 173.35 122.78 173.35 127.27 164.71 158.78 164.71"
            />
            <polygon
                className="cls-3"
                points="190.41 164.71 186.46 172.27 169.55 172.27 166.64 177.86 182.94 177.86 179.16 184.99 162.88 184.99 159.27 191.87 177.61 191.87 173.41 199.89 144.78 199.89 163.17 164.71 190.41 164.71"
            />
            <polygon
                className="cls-3"
                points="228.65 164.71 210.22 199.89 200.58 199.89 198.88 179.44 198.79 179.44 188.1 199.89 178.41 199.89 196.84 164.71 206.48 164.71 208.13 185.2 208.22 185.2 218.97 164.71 228.65 164.71"
            />
            <path
                className="cls-3"
                d="M242.26,186.67l3.08-12.82h-.09l-9.83,12.82Zm7,13.22h-10.1l1.39-5.76H229.66l-4.43,5.76h-11.1l30.09-35.18h11Z"
            />
            <polygon
                className="cls-3"
                points="282.31 164.71 263.9 199.89 253.47 199.89 271.87 164.71 282.31 164.71"
            />
            <polygon
                className="cls-3"
                points="334.21 164.71 329.74 173.35 318.92 173.35 304.99 199.89 294.64 199.89 308.55 173.35 298.21 173.35 302.7 164.71 334.21 164.71"
            />
            <polygon
                className="cls-3"
                points="349.56 164.71 331.15 199.89 320.72 199.89 339.13 164.71 349.56 164.71"
            />
            <polygon
                className="cls-3"
                points="385.96 164.71 381.49 173.35 370.67 173.35 356.73 199.89 346.39 199.89 360.3 173.35 349.95 173.35 354.45 164.71 385.96 164.71"
            />
            <polygon
                className="cls-3"
                points="403.34 191.3 398.88 199.89 372.01 199.89 390.35 164.71 400.74 164.71 386.81 191.3 403.34 191.3"
            />
            <polygon
                className="cls-3"
                points="448.65 164.71 444.7 172.27 427.79 172.27 424.88 177.86 441.19 177.86 437.4 184.99 421.12 184.99 417.51 191.87 435.86 191.87 431.65 199.89 403.02 199.89 421.41 164.71 448.65 164.71"
            />
            <polyline
                className="cls-4"
                points="833.26 11.88 810.92 65.57 883.82 65.57 834.22 153.68 899.54 153.68 947.67 65.41 1023.09 65.41 1053.8 11.88"
            />
            <path
                className="cls-4"
                d="M575.57,153.83,649.9,12.09H767.17q23.63,0,34.88,2.05t18.54,6.93q7.51,4.79,9.16,12T827,48.8q-6.48,12.36-21.28,20.49T769.36,80.52Q791,83.4,798.36,92t.12,22.45q-10.14,19.35-36.9,29.37t-68.4,10Zm85-31.22h36.2q12.24,0,20.9-3.4t11.85-9.47q3.24-6.18-1.84-9.62t-17.31-3.45h-36.2Zm29.5-56.26h35.18q11,0,18.79-3.09t10.67-8.68q3-5.69-1.52-8.78t-15.54-3.09H702.5Z"
            />
            <polyline
                className="cls-1"
                points="830.5 4.28 808.16 57.98 881.06 57.98 831.46 146.08 896.78 146.08 944.91 57.81 1020.33 57.81 1051.04 4.28"
            />
            <path
                className="cls-1"
                d="M572.81,146.23,647.14,4.49H764.41q23.63,0,34.88,2.05t18.54,6.93q7.51,4.78,9.16,12T824.2,41.2q-6.5,12.36-21.29,20.5T766.6,72.92q21.6,2.88,29,11.47t.13,22.44q-10.15,19.35-36.91,29.37t-68.39,10Zm85-31.22h36.2q12.24,0,20.9-3.39t11.85-9.48Q730,96,725,92.52t-17.32-3.45h-36.2Zm29.5-56.26h35.18q11.06,0,18.79-3.09T752,47q3-5.68-1.52-8.77t-15.54-3.1H699.75Z"
            />
            <path
                className="cls-3"
                d="M572.81,199.46l20.56-34.71H612a31.69,31.69,0,0,1,4.75.29,6.18,6.18,0,0,1,2.6.88,4.67,4.67,0,0,1,2,3.32,7.51,7.51,0,0,1-1.3,4.39,14.14,14.14,0,0,1-3.46,3.94,18.41,18.41,0,0,1-5,2.76,4.23,4.23,0,0,1,2.64,3.28,8,8,0,0,1-1.43,5.1,19.81,19.81,0,0,1-3,3.82,24.65,24.65,0,0,1-4,3.2,22.14,22.14,0,0,1-6.55,2.87,37.3,37.3,0,0,1-8.84.86Zm19.75-14.6-3.89,6.56h6.41a9.19,9.19,0,0,0,4-.8,6.21,6.21,0,0,0,2.64-2.47c.65-1.11.75-1.94.28-2.48s-1.53-.81-3.18-.81Zm7.22-12.2-3.34,5.63h5.4a9,9,0,0,0,3.81-.67,5.45,5.45,0,0,0,2.34-2.21c.57-1,.64-1.67.19-2.1s-1.46-.65-3-.65Z"
            />
            <path
                className="cls-3"
                d="M622.43,182a37.34,37.34,0,0,1,5.6-7.29,41.31,41.31,0,0,1,7.39-5.89,33.63,33.63,0,0,1,7.92-3.67,27.35,27.35,0,0,1,8.08-1.24,15.53,15.53,0,0,1,6.54,1.21,7.66,7.66,0,0,1,3.8,3.57,9.41,9.41,0,0,1,.66,6,23.07,23.07,0,0,1-3,7.54,37.44,37.44,0,0,1-5.56,7.22,40.05,40.05,0,0,1-7.35,5.83,34.27,34.27,0,0,1-8,3.76,27.11,27.11,0,0,1-8.08,1.26,15.33,15.33,0,0,1-6.5-1.21,7.57,7.57,0,0,1-3.75-3.58,9.52,9.52,0,0,1-.71-6A22.8,22.8,0,0,1,622.43,182Zm11.37.17c-1.83,3.09-2.61,5.49-2.35,7.18s1.56,2.55,3.86,2.55a10.91,10.91,0,0,0,6.56-2.7A25.29,25.29,0,0,0,648,182q2.73-4.62,2.33-7.16t-3.85-2.55a11,11,0,0,0-6.56,2.69A25.24,25.24,0,0,0,633.8,182.19Z"
            />
            <path
                className="cls-3"
                d="M656.22,199.46l20.55-34.71H688.1l-.18,15.45a23.06,23.06,0,0,1-.24,2.77,13.49,13.49,0,0,1-.6,2.43l.37-.13a13,13,0,0,1,1-2.9c.49-1.07,1.31-2.56,2.43-4.47l7.79-13.15h10.67l-20.55,34.71H677.53l.4-16.14a17.67,17.67,0,0,1,.27-2.57,19.74,19.74,0,0,1,.66-2.68l-.36.13a17.85,17.85,0,0,1-1.16,3.2,46.47,46.47,0,0,1-2.26,4.21l-8.2,13.85Z"
            />
            <path
                className="cls-3"
                d="M697.35,199.46l20.55-34.71h11.33l-.18,15.45a21.17,21.17,0,0,1-.24,2.77,14.38,14.38,0,0,1-.59,2.43l.36-.13a13.55,13.55,0,0,1,1-2.9c.49-1.07,1.31-2.56,2.44-4.47l7.78-13.15h10.67l-20.55,34.71H718.66l.4-16.14a17.67,17.67,0,0,1,.27-2.57,21.35,21.35,0,0,1,.66-2.68l-.36.13a17.1,17.1,0,0,1-1.16,3.2,46.47,46.47,0,0,1-2.26,4.21L708,199.46Z"
            />
            <path
                className="cls-3"
                d="M738.48,199.46,759,164.75H790l-5,8.4H765.05l-2.69,4.55h17.25l-4.56,7.7H757.81l-3.16,5.33H774.9l-5.18,8.73Z"
            />
            <path
                className="cls-3"
                d="M776.94,199.46l20.55-34.71h19c4.48,0,7.42.89,8.84,2.68s1.17,4.31-.75,7.54a16.71,16.71,0,0,1-4.84,5.19,19.76,19.76,0,0,1-6.85,3.09c1.78.64,2.79,1.54,3,2.7s-.3,2.9-1.59,5.21c-.44.79-1,1.83-1.76,3.1-1.5,2.54-1.88,3.82-1.16,3.83h.18l-.8,1.37H799.36a18.39,18.39,0,0,1,1.81-4.62,36.77,36.77,0,0,0,1.76-3.68c.51-1.43.54-2.45.06-3.07s-1.51-.92-3.11-.92h-4.52l-7.28,12.29Zm22.8-19.7h5.73a10.37,10.37,0,0,0,4.42-.85,6.2,6.2,0,0,0,2.8-2.53c.7-1.17.79-2,.29-2.63s-1.62-.88-3.34-.88h-5.82Z"
            />
            <path
                className="cls-3"
                d="M851.05,173.37l5.1-8.62h34.56l-5.11,8.62H873.92l-15.45,26.09H847.28l15.45-26.09Z"
            />
            <path
                className="cls-3"
                d="M877.23,199.46l20.55-34.71h11.38l-20.55,34.71Z"
            />
            <path
                className="cls-3"
                d="M911.17,173.37l5.11-8.62h34.55l-5.1,8.62H934L918.6,199.46H907.41l15.45-26.09Z"
            />
            <path
                className="cls-3"
                d="M937,199.46l20.55-34.71h11.24l-15.32,25.87h15.11l-5.23,8.84Z"
            />
            <path
                className="cls-3"
                d="M970,199.46l20.56-34.71h30.91l-5,8.4H996.57l-2.69,4.55h17.24l-4.56,7.7H989.32l-3.16,5.33h20.25l-5.17,8.73Z"
            />
            <polygon
                className="cls-4"
                points="451.31 65.09 480.99 11.39 202.13 11.39 119.94 59.44 141.38 11.39 78 11.39 4.42 153.61 69.11 153.61 81.07 132 123.83 108.78 154.31 153.61 226.69 153.61 177.27 82.18 259.88 39.61 246.27 65.25 316.72 65.25 268.78 153.61 331.91 153.61 378.43 65.09 451.31 65.09"
            />
            <polygon
                className="cls-1"
                points="446.89 57.75 476.57 4.06 197.72 4.06 115.53 52.1 136.96 4.06 73.58 4.06 0 146.27 64.7 146.27 76.66 124.67 119.41 101.45 149.9 146.27 222.28 146.27 172.86 74.84 255.46 32.27 241.85 57.91 312.3 57.91 264.37 146.27 327.5 146.27 374.01 57.75 446.89 57.75"
            />
        </g>
    </svg>
)

export default LogoInline;